import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useMeteringRecord} from '../hooks/useMeteringRecord';
import {MeteringRecord} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useMeteringRecord();

    return (
        <FormDrawer
            record={{
                id: '',
                productCode: '',
                usageRecords: [],
            } as unknown as MeteringRecord}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
